import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { v4 as uuidv4 } from "uuid";
import { updateBigQueryDataAstera } from "../../../../api/postCall/updateBigQueryDataAstera";
import { NycbsPharmaOrderKeys } from "../../../../enums/nycbsPharmaOrder";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";

interface OnAsteraSaveParams {
  data: any;
  routeVia: string;
  response_status: string;
  pa_outcome_classification: string;
  comments?: string;
  key: string;
  /**
   * When true the CMM key was edited, so the previous key's Second STP Status is stale and is
   * blanked. The column is not otherwise part of this modal, and the backend's key-change
   * trigger preserves it, so it can only be cleared by sending it explicitly.
   */
  clearSecondStpStatus?: boolean;
  onSuccess: () => void;
  onError: (error: Error) => void;
}

export const onAsteraSave = async (params: OnAsteraSaveParams) => {
  const {
    data,
    routeVia,
    response_status,
    pa_outcome_classification,
    comments,
    key,
    clearSecondStpStatus,
    onSuccess,
    onError,
  } = params;

  try {
    const identifier =
      data?.[NycbsPharmaOrderKeys.Identifier] || data?.identifier;
    if (!identifier) {
      throw new Error("Identifier not found in data");
    }

    const org_id = getOrgIdForFetchExternalWorklist();
    if (!org_id) {
      throw new Error("Organization ID not found");
    }
    const payload = {
      filters: {
        identifier: identifier,
      },
      org_id: org_id,
      update_data: {
        covermymed_id: key,
        response_status: response_status,
        pa_outcome_classification: pa_outcome_classification,
        route_via: routeVia,
        comments: comments,
        ...(clearSecondStpStatus ? { second_stp_status: "" } : {}),
      },
      request_id: uuidv4(),
    };

    await updateBigQueryDataAstera(payload);
    toast.success("Astera submission saved successfully");

    // Call success callback
    onSuccess();
  } catch (error) {
    // Log only generic error message, not full error object which may contain sensitive data
    console.error("Error in Astera submission save");
    onError(error as Error);
  }
};
